// material
import MaterialTable from 'material-table';

export default function ProdTable(props) {
  const { data } = props;

  // const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
  //   <Typography variant={variant} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
  //     {`Product Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
  //   </Typography>
  // );

  const columns = [
    {
      title: 'Name',
      field: 'name',
    },
    {
      title: 'Added To Cart',
      field: 'add_to_cart',
    },
    {
      title: 'Detail Page',
      field: 'detail',
    },
    {
      title: 'Specification',
      field: 'specs',
    },
    {
      title: 'What included',
      field: 'includes',
    },
    {
      title: 'Conversion',
      field: 'conv',
    },
  ];

  return (
    <MaterialTable
      title="Products"
      columns={columns}
      data={data}
      // title={<MyNewTitle variant="h6" />}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
      }}
    />
  );
}
